(ns frontend.ux-overhaul.listing.holding.view
  (:require [common.localization :as loc]
            [common.opensearch.row :as os-row]
            [frontend.routing :as routing]
            [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.ux-overhaul.listing.generic.event :as generic-event]
            [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
            [frontend.ux-overhaul.listing.generic.menu-actions :as menu-actions]
            [frontend.ux-overhaul.listing.generic.view :as listing]
            [frontend.ux-overhaul.listing.holding.event :as holding-event]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(def listing-id "holding-listing")

(defn- open-holding!
  [value]
  (when-let [entity-id (os-row/entity-id value)]
    (routing/open-entity {:db/id       entity-id
                          :entity/type :entity.type/holding})))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id           listing-id
         :entity-type          :entity.type/holding
         :pipeline-id          nil
         :filters              {:enabled? true
                                :view-id :holding
                                :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes #{:grid :kanban :gallery :list}
         :toolbar-actions      [{:id       :create-holding
                                 :label    (loc/tr :holding-add-button)
                                 :visible? true
                                 :enabled? true
                                 :event    [::holding-event/create-holding]}
                                {:id                  :bulk-edit-holdings
                                 :label               (loc/tr :bulk-edit)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :event               [::holding-event/open-bulk-edit {:listing-id listing-id}]}
                                {:id                  :bulk-delete-holdings
                                 :label               (loc/tr :confirm-delete-selected-button)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :variant             :danger
                                 :event               [::holding-event/bulk-delete-selected {:listing-id listing-id}]}
                                {:id       :export-holdings
                                 :label    (loc/tr :save-as-excel)
                                 :visible? true
                                 :enabled? true
                                 :event    [::holding-event/export-grid {:listing-id listing-id}]}
                                {:id       :export-holdings-with-persons
                                 :label    (loc/tr :save-as-excel-all-data)
                                 :visible? true
                                 :enabled? true
                                 :event    [::holding-event/export-grid-with-persons {:listing-id listing-id}]}
                                (menu-actions/field-requirements-action {:entity-type :entity.type/holding})]}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      [:<>
       [listing/view
        {:listing-id               listing-id
         :title                    (loc/tr :holdings)
         :show-view-mode-selector? true
         :query-placeholder        (loc/tr :listing.holding/search-placeholder)
         :on-create-first-item     #(rf/dispatch [::holding-event/create-holding])
         :on-row-clicked           open-holding!
         :on-card-clicked          open-holding!}]
       [bulk-actions/bulk-edit-modal
        {:listing-id  listing-id
         :entity-type :entity.type/holding}]
       [menu-actions/field-requirements-modal]])}))
